/* global Ad */
import '@PROJECT_ROOT/assets/desktop/js/jquery/ui/jquery.ui.sortable.min';
import '@PROJECT_ROOT/assets/desktop/js/jquery/plugins/jquery.dragtable';
import compareTable from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/compareTable';
import { unitFavoriteToggleButton } from '@PROJECT_ROOT/assets/desktop/js/privateAccommodation/Favorites';

$(() => {
    const $compareTableData = $('#compareTableData');
    const unitIds = $compareTableData.data('compare-units');

    if (unitIds.length) {
        unitFavoriteToggleButton();
        initCompareTable($compareTableData);
        initHorizontalForm();
    }
});

function initCompareTable($compareTableData) {
    compareTable.init({
        table: $('#compareTable'),
        storageUnits: JSON.parse(window.localStorage.getItem('tableorder')), // units in sessionStorage
        compareUnits: $compareTableData.data('compare-units'), // units in compare list
        unitGalleries: document.querySelectorAll('.unitGalleryWrapper'),
        calendarStartDate: $compareTableData.data('calendar-start-date'),
        calendarURL: $compareTableData.data('calendar-url'),
        $sortList: $('#compareSortList'),
        sortSelected: '.sortResults > span',
        row: {
            beach: $('#rowBeach'),
            area: $('#rowArea'),
            stars: $('#rowStars'),
            price: $('#rowPrice'),
        },
        noPricesDialog: $compareTableData.data('no-prices-text'),
    });

    // Uklanja jedinicu i refresha stranicu
    $('.compareRemoveItem').on('click', function removeItem() {
        const url = $(this).data('url-remove');
        $.post(url, { unitId: $(this).data('unit-id') }).then(() => { $('#form_remove').submit(); });
    });

    $('.clearCompareLink').on('click', function clearAllFromCompared() {
        const url = $(this).data('url-remove');
        $.post(url).then(() => { $('#form_remove').submit(); });
    });
}

function initHorizontalForm() {
    $('#form_compare').submit(function submitCompareForm(event) {
        event.preventDefault();
        $('#compareListLoader').show();
        $.ajax({
            url: $(this).attr('action'),
            async: false,
            type: 'POST',
            data: $(this).serialize(),
            dataType: 'html',
            context: $(this),
        }).then((data) => {
            window.location.href = data;
        });
    });

    Ad.Datepicker.initRange(
        '#compareForm_date_from',
        '#compareForm_date_to',
        { currentText: $('#currentText').data('text') },
    );
}
